import { render, staticRenderFns } from "./BarChartNeo.vue?vue&type=template&id=616735e4&"
import script from "./BarChartNeo.vue?vue&type=script&lang=js&"
export * from "./BarChartNeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports